import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import RightPanel from './RightPanel';
import './MainLayout.css';

const isDesktopViewport = () =>
    typeof window === 'undefined' ? true : window.innerWidth > 992;

function MainLayout({ children }) {
    const [sidebarOpen, setSidebarOpen] = useState(isDesktopViewport);
    const [isDesktop, setIsDesktop] = useState(isDesktopViewport);
    const [rightPanelOpen, setRightPanelOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const desktop = isDesktopViewport();
            setIsDesktop(desktop);
            setSidebarOpen(desktop);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="main-layout">
            {/* Sidebar */}
            <Sidebar 
                collapsed={!sidebarOpen} // Pass the actual collapsed state
                onToggle={() => setSidebarOpen(!sidebarOpen)} 
            />

            {/* Main Content Area */}
            <div className={`main-content ${!sidebarOpen ? 'sidebar-collapsed' : ''}`}>
                {/* Header */}
                <Header 
                    onSidebarToggle={() => setSidebarOpen(!sidebarOpen)}
                    onRightPanelToggle={() => setRightPanelOpen(!rightPanelOpen)} 
                    isDesktop={isDesktop}
                    isSidebarOpen={sidebarOpen}
                />

                {/* Page Content */}
                <div className="page-content">
                    {children}
                </div>
            </div>

            {/* Right Panel */}
            <RightPanel 
                isOpen={rightPanelOpen} 
                onClose={() => setRightPanelOpen(false)} 
            />

            {!isDesktop && sidebarOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={() => setSidebarOpen(false)}
                    aria-hidden="true"
                />
            )}
        </div>
    );
}

export default MainLayout;
